var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTenantEmergency(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.353,
    height: 23.848,
    viewBox: "0 0 24.353 23.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2538738_emergency_light_police_security_icon",
    "data-name": "2538738_emergency_light_police_security_icon",
    transform: "translate(-2 -2.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11918",
    "data-name": "Group 11918",
    transform: "translate(13.356 2.498)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1419",
    "data-name": "Rectangle 1419",
    width: 1.136,
    height: 3.407,
    transform: "translate(0 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11919",
    "data-name": "Group 11919",
    transform: "translate(2.001 13.853)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1420",
    "data-name": "Rectangle 1420",
    width: 3.407,
    height: 1.136,
    transform: "translate(0 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11920",
    "data-name": "Group 11920",
    transform: "translate(22.441 13.853)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1421",
    "data-name": "Rectangle 1421",
    width: 3.407,
    height: 1.136,
    transform: "translate(0 0)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11921",
    "data-name": "Group 11921",
    transform: "translate(21.366 4.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1422",
    "data-name": "Rectangle 1422",
    width: 3.044,
    height: 1.015,
    transform: "translate(0 2.153) rotate(-45)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11922",
    "data-name": "Group 11922",
    transform: "translate(4.117 4.107)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1423",
    "data-name": "Rectangle 1423",
    width: 1.015,
    height: 3.044,
    transform: "translate(0 0.717) rotate(-45)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11923",
    "data-name": "Group 11923",
    transform: "translate(6.059 7.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8070",
    "data-name": "Path 8070",
    d: "M10,25.667h7.61v-5.84L16.342,21.1l-2.152-2.152.717-.717,1.435,1.435,1.775-1.776,1.776,1.776,1.435-1.435.717.717L19.893,21.1l-1.269-1.268v5.84h7.61V19.62A8.118,8.118,0,0,0,10,19.62Z",
    transform: "translate(-10 -11.502)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924",
    transform: "translate(2 22.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8071",
    "data-name": "Path 8071",
    d: "M22.761,41.422H5.592A3.592,3.592,0,0,0,2,45.014v.507H26.353v-.507A3.592,3.592,0,0,0,22.761,41.422Z",
    transform: "translate(-2 -41.422)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantEmergency);
export default __webpack_public_path__ + "static/media/tenant_emergency.69ec222b585208b08b7a929ab86a9e65.svg";
export { ForwardRef as ReactComponent };